export const SET_PARENTS_TREE = "SET_PARENTS_TREE";

export const setParentsTree = (parentsMap) => ({
  type: SET_PARENTS_TREE,
  payload: {
    parentsTree: parentsMap,
  },
});
